import { createFileRoute } from '@tanstack/react-router';

import { Agent } from '../../pages';

export const Route = createFileRoute('/_agent')({
  component: Agent,
});
